module.exports = __webpack_public_path__ + "static/C24_Communities-26536754b9a94f6b548f7525929702ec.svg";